import React, { memo, useState } from "react";
import { CopyableIdProps } from "./types";

export const CopyableId: React.FC<CopyableIdProps> = memo(({ id }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(id.toString());
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <span
      className="group cursor-pointer text-sm text-gray-600"
      onClick={handleCopy}
    >
      <span className={!copied ? "group-hover:hidden" : ""}>
        {copied ? "Copied to clipboard ✅" : `ID: ${id}`}
      </span>
      <span className={`hidden ${copied ? "" : "group-hover:block"}`}>
        Click to Copy...
      </span>
    </span>
  );
});
